export default "__VITE_ASSET__CGE7R9pP__"